import { Box, Chip, TextField } from "@common-ui/ui";

const Tags = ({ data, handleDelete, dataItem, doesUserHavePermission }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        p: 0.5,
      }}
    >
      <Chip
        disabled={doesUserHavePermission}
        key={dataItem}
        label={data}
        onDelete={() => {
          handleDelete(data);
        }}
      />
    </Box>
  );
};

export default function DomainInputTags({
  onDomainChange,
  tagValues,
  setTagValues,
  forwardedRef,
  doesUserHavePermission,
}) {
  const handleDelete = (value) => {
    const newtags = tagValues.tags.filter((val) => val !== value);
    setTagValues({ tags: newtags });
  };

  const handleChange = (name) => (event) => {
    setTagValues({ ...tagValues, [name]: event.target.value });
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <TextField
        disabled={doesUserHavePermission}
        onChange={handleChange("tag")}
        onKeyDown={onDomainChange}
        inputRef={forwardedRef}
        fullWidth
        size="normal"
        sx={{ mt: 0 }}
        placeholder={tagValues.tags.length === 0 ? "Enter domains" : ""}
        InputProps={{
          startAdornment: (
            <Box sx={{ margin: "0 0.2rem 0 0", display: "flex" }}>
              {tagValues.tags.length > 0
                ? tagValues.tags.map((data, index) => {
                    return (
                      <Tags
                        doesUserHavePermission={doesUserHavePermission}
                        data={data}
                        handleDelete={handleDelete}
                        dataItem={index}
                        key={index}
                      />
                    );
                  })
                : ""}
            </Box>
          ),
        }}
      />
    </Box>
  );
}
